import { Injectable } from '@angular/core';
import { LocationBusinessService } from 'src/app/core/business/location/location-business.service';

@Injectable({
  providedIn: 'root'
})
export class LocationFacadesService {

  constructor(
    private locationBusinessService: LocationBusinessService
  ) { }

  getLocationList(clientId) {
    return this.locationBusinessService.getLocationList(clientId);
  }

  getCountryList() {
    return this.locationBusinessService.getCountryList();
  }

  getStateList(country) {
    return this.locationBusinessService.getStateList(country);
  }

  createLocation(data) {
    return this.locationBusinessService.createLocation(data);
  }

  getTimezone(paramsReq) {
    return this.locationBusinessService.getTimezone(paramsReq);
  }
}
